import { RankTrackerQueryType } from "app/pages/digital-marketing/keywords-campaigns/shared/constants";
import { createCampaignQueryKey } from "app/pages/digital-marketing/keywords-campaigns/shared/utils";

export const queryKeys = {
    status: (campaignId: string) => createCampaignQueryKey(campaignId, RankTrackerQueryType.AITaggingStatus),
    initialCategories: (campaignId: string) =>
        createCampaignQueryKey(campaignId, RankTrackerQueryType.AITaggingCategories),
    keywordsTable: (campaignId: string) => createCampaignQueryKey(campaignId, RankTrackerQueryType.KeywordsTable),
};
